import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { ru } from 'vuetify/locale'
import { createVuetify, type ThemeDefinition } from 'vuetify'

import { communicationIconAliases } from '@/icons/communicationIcons'

export const avoschoolLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#B9F466',
    'primary-darken-1': '#A7E252',
    'on-primary': '#11120F',
    secondary: '#62635C',
    'on-secondary': '#FFFFFF',
    success: '#397D45',
    info: '#4458D9',
    warning: '#925B00',
    error: '#E5533F',
    background: '#F1EFE6',
    'on-background': '#292B25',
    surface: '#FCFBF6',
    'on-surface': '#292B25',
    'surface-bright': '#FFFEF9',
    'surface-variant': '#E8E5DA',
    'on-surface-variant': '#62635C',
    outline: '#CBC9BD',
  },
  variables: {
    'border-color': '#2E2938',
    'border-opacity': 0.1,
    'high-emphasis-opacity': 0.9,
    'medium-emphasis-opacity': 0.68,
    'disabled-opacity': 0.42,
    'hover-opacity': 0.05,
    'focus-opacity': 0.1,
    'selected-opacity': 0.09,
    'activated-opacity': 0.12,
    'pressed-opacity': 0.14,
  },
}

export const avoschoolDarkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary: '#C1FF6A',
    'primary-darken-1': '#AEEA58',
    'on-primary': '#11120F',
    secondary: '#AAA8A0',
    'on-secondary': '#10110E',
    success: '#78D69D',
    info: '#8BB7F3',
    warning: '#EDC065',
    error: '#F08A95',
    background: '#10110E',
    'on-background': '#E6E5DF',
    surface: '#171914',
    'on-surface': '#E6E5DF',
    'surface-bright': '#20231C',
    'surface-variant': '#292C24',
    'on-surface-variant': '#AAA8A0',
    outline: '#4B4B44',
  },
  variables: {
    'border-color': '#EEEAF4',
    'border-opacity': 0.11,
    'high-emphasis-opacity': 0.92,
    'medium-emphasis-opacity': 0.7,
    'disabled-opacity': 0.42,
    'hover-opacity': 0.06,
    'focus-opacity': 0.11,
    'selected-opacity': 0.1,
    'activated-opacity': 0.14,
    'pressed-opacity': 0.16,
  },
}

const savedTheme = typeof window === 'undefined'
  ? 'avoschoolLight'
  : localStorage.getItem('avoschool.theme') === 'dark'
    ? 'avoschoolDark'
    : 'avoschoolLight'

export const vuetify = createVuetify({
  defaults: {
    VAlert: {
      density: 'comfortable',
      rounded: 'lg',
      variant: 'tonal',
    },
    VAutocomplete: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
      variant: 'outlined',
    },
    VBtn: {
      color: 'primary',
      rounded: 'lg',
      style: 'text-transform: none; letter-spacing: 0;',
    },
    VCard: {
      elevation: 0,
      rounded: 'lg',
    },
    VCheckbox: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
    },
    VChip: {
      rounded: 'sm',
    },
    VCombobox: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
      variant: 'outlined',
    },
    VDialog: {
      scrollable: true,
    },
    VSelect: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
      variant: 'outlined',
    },
    VSwitch: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
      inset: true,
    },
    VTextField: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
      variant: 'outlined',
    },
    VTextarea: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
      variant: 'outlined',
    },
    VTooltip: {
      location: 'top',
    },
  },
  icons: {
    aliases: {
      ...aliases,
      ...communicationIconAliases,
    },
    defaultSet: 'mdi',
    sets: { mdi },
  },
  locale: {
    locale: 'ru',
    fallback: 'ru',
    messages: { ru },
  },
  theme: {
    defaultTheme: savedTheme,
    themes: {
      avoschoolLight: avoschoolLightTheme,
      avoschoolDark: avoschoolDarkTheme,
    },
  },
})

export default vuetify
